import React, { useState, useEffect } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Input } from "./ui/input";

interface ImageUploaderProps {
  value: string | undefined;
  onChange?: (value: string) => void;
  onValueChange?: (value: string) => void;
  disabled?: boolean;
}

export const ImageUploader: React.FC<ImageUploaderProps> = ({ value, onChange, onValueChange, disabled }) => {
  const [preview, setPreview] = useState<string | undefined>(value);

  // Update preview when value changes from outside
  useEffect(() => {
    setPreview(value);
  }, [value]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        setPreview(base64String);
        // Call whichever callback is provided
        if (onChange) onChange(base64String);
        if (onValueChange) onValueChange(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="flex items-center gap-4">
      <Avatar className="w-24 h-24">
        <AvatarImage src={preview} alt="User's profile picture" />
        <AvatarFallback>??</AvatarFallback>
      </Avatar>
      <div className="grid gap-2">
        <Label htmlFor="picture">Foto de perfil</Label>
        <Input id="picture" type="file" onChange={handleFileChange} disabled={disabled} className="max-w-xs" />
        <p className="text-xs text-muted-foreground">Sube una imagen para tu perfil.</p>
      </div>
    </div>
  );
};
